module.exports = __webpack_public_path__ + "./favicons/android-icon-48x48.png";